export const accessKey = 'HL4dIuVckUL5cWjwpTB0MDpXq8gfZREGiAA9I-B0c_A';
export const secretKey = 'nZIYk4p4d7_hV2vV4iJfNhEaOR6fySlsJt_YfSpmgss';
export const REDIRECT_URI = 'urn:ietf:wg:oauth:2.0:oob'
export const OAUTH_AUTHORIZE_URL = "https://unsplash.com/oauth/authorize";
export const OAUTH_TOKEN_URL = "https://unsplash.com/oauth/token";

// export default {accessKey, secretKey};